import {useState} from 'react'
import {
  PasswordValidationContainer,
  MainContainer,
  Heading,
  Paragraph,
  Input,
  ErrorMsg,
} from './styledComponents'

const PasswordValidation = () => {
  const [password, setPassword] = useState('')

  const onChangePassword = event => {
    setPassword(event.target.value)
  }
  return (
    <PasswordValidationContainer>
      <MainContainer>
        <Heading>Password Validator</Heading>
        <Paragraph>Check how strong and secure is your password</Paragraph>
        <Input type="password" onChange={onChangePassword} />
        {password.length < 8 ? (
          <ErrorMsg>Your password must be at least 8 characters</ErrorMsg>
        ) : null}
      </MainContainer>
    </PasswordValidationContainer>
  )
}
export default PasswordValidation
